import { Home, CircleCheckBig, ClipboardList, CircleUserRound, Info } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
// import { useChatStore } from '@/store/chatStore'
import { useGetActiveConsultation } from '@/hooks/queries/chat'
import { useHasUnreadMyReports } from '@/hooks/queries/report'
import { openNativeChatPage } from '@/utils/webViewBridge'

type BottomNavBarTab = 'home' | 'mission' | 'chat' | 'report' | 'my' | 'notice'

const BottomNavBar = () => {
  const location = useLocation()
  const [activeTab, setActiveTab] = useState<BottomNavBarTab>('home')
  const navigate = useNavigate()

  // const { recentChatPage } = useChatStore()
  const { data: activeConsultation } = useGetActiveConsultation()
  const { data: hasUnreadReports } = useHasUnreadMyReports()

  const handleClickChat = () => {
    if (activeConsultation && activeConsultation.consultation_id) {
      // 진행 중인 상담이 있으면 네이티브 채팅 페이지로 이동
      openNativeChatPage(activeConsultation.consultation_id, '/chat')
    } else {
      // 진행 중인 상담이 없으면 상담 메인 페이지로 이동
      navigate('/chat')
    }
  }

  useEffect(() => {
    if (location.pathname === '/') {
      setActiveTab('home')
    } else if (location.pathname.includes('/mission')) {
      setActiveTab('mission')
    } else if (location.pathname.includes('/chat')) {
      setActiveTab('chat')
    } else if (location.pathname.includes('/report')) {
      setActiveTab('report')
    } else if (location.pathname.includes('/notice')) {
      setActiveTab('notice')
    } else if (location.pathname.includes('/my')) {
      setActiveTab('my')
    }
  }, [location.pathname])

  return (
    <div className='fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-100'>
      <div className='flex justify-around items-center py-2'>
        <button
          className={twMerge('flex flex-col items-center gap-1 py-2 px-4', activeTab === 'home' && 'text-amber-600')}
          onClick={() => navigate('/')}
        >
          <Home className={twMerge('w-6 h-6', activeTab === 'home' && 'text-amber-600')} />
          <span className='text-xs font-medium'>홈</span>
        </button>
        <button
          className={twMerge('flex flex-col items-center gap-1 py-2 px-4', activeTab === 'mission' && 'text-amber-600')}
          onClick={() => navigate('/mission')}
        >
          <CircleCheckBig className={twMerge('w-6 h-6', activeTab === 'mission' && 'text-amber-600')} />
          <span className='text-xs'>미션</span>
        </button>
        <button
          className={twMerge('flex flex-col items-center gap-1 py-2 px-4', activeTab === 'chat' && 'text-amber-600')}
          // onClick={() => {
          //   if (recentChatPage) {
          //     if (location.pathname !== `/chat/${recentChatPage}`) navigate(`/chat/${recentChatPage}`)
          //   } else {
          //     navigate('/chat')
          //   }
          // }}
          onClick={handleClickChat}
        >
          <CircleUserRound className={twMerge('w-6 h-6', activeTab === 'chat' && 'text-amber-600')} />
          <span className='text-xs'>상담</span>
        </button>
        <button
          className={twMerge(
            ' relative flex flex-col items-center gap-1 py-2 px-4',
            activeTab === 'report' && 'text-amber-600'
          )}
          onClick={() => navigate('/report')}
        >
          {hasUnreadReports && <div className=' w-2 h-2 absolute top-1 right-4 rounded-2xl bg-red-500' />}

          <ClipboardList className={twMerge('w-6 h-6', activeTab === 'report' && 'text-amber-600')} />
          <span className='text-xs'>리포트</span>
        </button>
        <button
          className={twMerge('flex flex-col items-center gap-1 py-2 px-4', activeTab === 'my' && 'text-amber-600')}
          onClick={() => navigate('/my')}
        >
          <Info className={twMerge('w-6 h-6', activeTab === 'my' && 'text-amber-600')} />
          <span className='text-xs'>My</span>
        </button>
      </div>
    </div>
  )
}

export default BottomNavBar
